// extracted by mini-css-extract-plugin
export default {"li":"Opening_li__TmZUp","h1":"Opening_h1__hgCiN","detail":"Opening_detail__806Ux","p":"Opening_p__xy6ap","span":"Opening_span__SzCku"};